import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context';
import { theme } from 'ant-design-vue';

const commonToken = {
  controlHeight: 32,
  controlHeightLG: 36,
  controlHeightSM: 24,
};

export const themeConfig: Record<'light' | 'dark', ThemeConfig> = {
  light: {
    algorithm: theme.defaultAlgorithm,
    token: {
      ...commonToken,
      colorPrimary: '#6962FF', // 确认
      colorPrimaryHover: '#8580ff', // 确认
      colorPrimaryBorder: '#dddcff', // 确认
      colorPrimaryBorderHover: '#cdcbff', // 确认
      colorPrimaryBg: '#e9ecff', // 确认
      colorPrimaryBgHover: '#f3f4ff', // 确认
      colorPrimaryActive: '#5650dc', // 确认

      colorSuccess: '#00D5A6', // 确认
      colorSuccessActive: '#00b28d', // 确认
      colorSuccessHover: '#3adcb6', // 确认
      colorSuccessBorder: '#9ff3dc', // 确认
      colorSuccessBorderHover: '#76e2c7', // 确认
      colorSuccessBg: '#e8fbf5', // 确认
      colorSuccessBgHover: '#d5faef', // 确认

      colorWarning: '#FFB53D', // 确认
      colorWarningActive: '#d99029', // 确认
      colorWarningHover: '#ffc964', // 确认
      colorWarningBorder: '#ffe9b1', // 确认
      colorWarningBorderHover: '#ffda8b', // 确认
      colorWarningBg: '#fff8eb', // 确认
      colorWarningBgHover: '#fff5d8', // 确认

      colorError: '#FF5656', // 确认
      colorErrorActive: '#d93f44', // 确认
      colorErrorHover: '#ff827e', // 确认
      colorErrorBorder: '#ffd6d1', // 确认
      colorErrorBorderHover: '#ffaea8', // 确认
      colorErrorBg: '#fff5f3', // 确认
      colorErrorBgHover: '#ffece9', // 确认

      colorInfo: '#6962FF',

      colorTextBase: 'rgba(18,25,38,1)', // #121926
      colorTextDisabled: 'rgba(18,25,38,0.2)',

      colorLink: '#6962FF',
      colorLinkHover: '#8580FF',
      colorLinkActive: '#5650DC',
    },
    components: {
      Button: {
        controlHeightLG: 36,
        fontSizeLG: 14,
        borderRadius: 8,
        colorPrimaryHover: '#453CB8',
      },
      Input: {
        borderRadius: 8,
        controlHeightLG: 36,
        fontSizeLG: 13,
      },
      Select: {
        controlHeightLG: 36,
        fontSizeLG: 13,
        borderRadius: 8,
      },
      Table: {
        colorTextHeading: 'rgba(18, 25, 38, 1)',
        colorText: 'rgba(18, 25, 38, 0.8)',
        padding: 24,
        paddingContentVerticalLG: 18,
      },
      Menu: {
        colorItemBgHover: '#f6f8f9',
        colorSubItemBg: 'transparent',
        colorItemBgSelected: '#F3F4FF',
        controlHeightLG: 44,
        colorItemText: '#121926',
        colorGroupTitle: '#e5e5e8',
      },
      Dropdown: {
        controlHeight: 32,
        controlHeightLG: 36,
      },
      Divider: {
        colorSplit: 'var(--text-1-20)',
      },
      Modal: {
        colorFillContent: 'var(--back-4)',
        colorTextDescription: 'var(--text-1)',
      },
    },
  },
  dark: {
    algorithm: theme.darkAlgorithm,
    token: {
      ...commonToken,
      colorPrimary: '#6962FF', // 确认
      colorPrimaryHover: '#524cc8', // 确认
      colorPrimaryBorder: '#333066', // 确认
      colorPrimaryBorderHover: '#3f3b99', // 确认
      colorPrimaryBg: '#1E1d42', // 确认
      colorPrimaryBgHover: '#f3f4ff', // 确认
      colorPrimaryActive: '#867ee8', // 确认

      colorSuccess: '#03B890', // 确认
      colorSuccessActive: '#22cea3', // 确认
      colorSuccessHover: '#079173', // 确认
      colorSuccessBorder: '#0e4e40', // 确认
      colorSuccessBorderHover: '#0b6b56', // 确认
      colorSuccessBg: '#112623', // 确认
      colorSuccessBgHover: '#0f3b33', // 确认

      colorWarning: '#D89221', // 确认
      colorWarningActive: '#e8af45', // 确认
      colorWarningHover: '#ad761c', // 确认
      colorWarningBorder: '#5c4218', // 确认
      colorWarningBorderHover: '#7e581a', // 确认
      colorWarningBg: '#2c2012', // 确认
      colorWarningBgHover: '#453113', // 确认

      colorError: '#dc4c4c', // 确认
      colorErrorActive: '#e87975', // 确认
      colorErrorHover: '#ad3f3f', // 确认
      colorErrorBorder: '#5b2828', // 确认
      colorErrorBorderHover: '#7e3232', // 确认
      colorErrorBg: '#2c1719', // 确认
      colorErrorBgHover: '#451f20', // 确认

      colorInfo: '#6962FF',

      colorTextBase: 'rgb(255,255,255)',
      colorBgContainer: 'rgb(10, 12, 16)',
      colorTextDisabled: 'rgba(255,255,255,0.2)',
      colorTextPlaceholder: 'rgba(255,255,255,.3)',
      colorLink: '#6962FF',
      colorLinkHover: '#524CC8',
      colorLinkActive: '#867EE8',

      // colorBgElevated: 'rgb(24, 28, 37)',
      colorBgMask: 'rgba(0, 0, 0, 0.6)',
    },
    components: {
      Button: {
        controlHeightLG: 36,
        fontSizeLG: 14,
        borderRadius: 8,
        colorPrimaryHover: '#453CB8',
      },
      Input: {
        borderRadius: 8,
        controlHeightLG: 36,
        fontSizeLG: 13,
        colorText: 'rgb(255,255,255)',
      },
      Select: {
        controlHeightLG: 36,
        fontSizeLG: 13,
        borderRadius: 8,
      },
      Table: {
        colorTextHeading: 'rgba(255, 255, 255, 1)',
        colorText: 'rgba(255, 255, 255, 0.8)',
        padding: 24,
        paddingContentVerticalLG: 18,
      },
      Modal: {
        colorText: 'rgb(255, 255, 255)',
        boxShadowSecondary: '0px 2px 20px 0px rgba(3,2,20,0.8)',
        colorBgElevated: 'var(--back-1)',
      },
      Popover: {
        colorText: 'rgb(255, 255, 255)',
        colorBgElevated: 'var(--back-1)',
      },
      Breadcrumb: {
        colorText: 'rgb(255, 255, 255)',
      },
      Badge: {
        colorBgContainer: 'rgb(255,255,255)', // 应该是antd代码取错了值
      },
      Menu: {
        colorItemBg: 'var(--back-4)',
        controlHeightLG: 44,
      },
      Message: {
        colorText: 'rgb(255,255,255)',
        colorBgElevated: 'rgb(24, 28, 37)',
      },
      Form: {
        colorText: 'rgb(255,255,255)',
      },
      Dropdown: {
        controlHeight: 32,
        controlHeightLG: 36,
        boxShadowSecondary: '0px 2px 20px 0px rgba(3,2,20,0.8)',
      },
      Tooltip: {
        colorBgDefault: '#181C25',
        boxShadowSecondary: '0px 2px 20px 0px rgba(3,2,20,0.8)',
        colorBgElevated: 'var(--back-1)',
      },
    },
  },
};
